import useVideoContext from './useVideoContext';
import useParticipants from './useParticipants';
import useSelectedParticipant from '../components/VideoProvider/useSelectedParticipant';
import useDominantSpeaker from './useDominantSpeaker';
import useScreenShareParticipant from './useScreenShareParticipant';

export default function useMainSpeaker() {
    const { participants, showWaitingMsg } = useParticipants();
    const [selectedParticipant] = useSelectedParticipant();
    const dominantSpeaker = useDominantSpeaker();
    // if selectedParticipant is connected then only show it in center.
    const showSelectedParticipant = selectedParticipant && selectedParticipant.state === "connected" ? selectedParticipant : null;
    const screenShareParticipant = useScreenShareParticipant();
    const {
        room: { localParticipant },
    } = useVideoContext();

    // local Participant does not want to see his own screen sharing tracks.
    const remoteScreenShareParticipant = screenShareParticipant !== localParticipant ? screenShareParticipant : null;

    // The participant that is returned is displayed in the main video area. Changing the order of the following
    // variables will change the how the main speaker is determined.  
    return remoteScreenShareParticipant || showSelectedParticipant || dominantSpeaker || participants[0] || localParticipant; // only remote or local is added for pilot release.
}
